module.exports = __webpack_public_path__ + "img/chambre.9191cf32.svg";